import EventTicketType from './EventTicketType';

export default EventTicketType;
